import React from "react";
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import btnArrowIcon from "../assets/icons/arrow-corner-right.svg";
import Applelogo from "../assets/icons/apple-icon.svg";

function DownlodApp({ BTNtext = "Join the network today", isHeroSection = false }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: "16px",
        margin: "2rem 0",
        alignItems: { xs: 'center', sm: 'flex-start' },
      }}
    >
      {isHeroSection
        ? <>
          <Box
            component="a"
            href="/plans"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "white",
              height: "4.8rem",
              borderRadius: "25px",
              color: "black",
              fontSize: "1.8rem",
              fontWeight: 600,
              textTransform: "none",
              p: '1rem 2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              gap: '1rem',
              width: 'fit-content'
            }}
          >
            Explore Plans
          </Box>

          <Box
            component="a"
            href="https://play.google.com/store/apps/details?id=com.split_ev_mobile.app"
            target="_blank"
            rel="noopener noreferrer"

            sx={{
              backgroundColor: "primary.main",
              height: "4.8rem",
              borderRadius: "25px",
              color: "black",
              fontSize: "1.8rem",
              fontWeight: 600,
              textTransform: "none",
              p: '1rem 2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              gap: '1rem',
              width: 'fit-content'
            }}
          >
            <Box
              component="img"
              src={Applelogo}
              alt="Apple logo"
              sx={{
                objectFit: "contain",
                height: "2rem",
              }}
            />
            Download for IOS
          </Box>

        </>
        : <Box
          component="a"
          // href="https://play.google.com/store/apps/details?id=com.split_ev_mobile.app"
          href="mailto:charge@splitev.co"
          target="_blank"
          rel="noopener noreferrer"

          sx={{
            backgroundColor: "white",
            height: "4.8rem",
            borderRadius: "20px",
            color: "black",
            fontSize: "1.6rem",
            fontWeight: 700,
            textTransform: "none",
            p: '1.2rem 2.4rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textDecoration: 'none',
            gap: '1rem',
          }}
        >
          {BTNtext}
          <Box
            component="img"
            src={btnArrowIcon}
            alt="Apple logo"
            sx={{
              objectFit: "contain",
              height: "2rem",
            }}
          />
        </Box>}
    </Box>
  );
}

DownlodApp.propTypes = {
  window: PropTypes.func,
};

export default DownlodApp;